module.exports = __webpack_public_path__ + "FernandFancyCreative.webp?d682a70c0ae43947b4e8bbf3bdf64524";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/FernandFancyCreative.webp
// module id = 85
// module chunks = 0